import { render, staticRenderFns } from "./CardStatsV8.vue?vue&type=template&id=6b63d89a&scoped=true&"
import script from "./CardStatsV8.vue?vue&type=script&lang=js&"
export * from "./CardStatsV8.vue?vue&type=script&lang=js&"
import style0 from "./CardStatsV8.vue?vue&type=style&index=0&id=6b63d89a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b63d89a",
  null
  
)

export default component.exports